import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {KladrService} from './kladr.service';

class Address {
    city_id: string;
    city?: string;
    index: string;
    address: string;
}

@Component({
    selector: 'address-fields',
    templateUrl: './address-fields.component.html'
})
export class AddressFieldsComponent implements OnInit, OnDestroy {
    /**
     * Группа и имена полей для города, инлекса и адреса
     * @type Address
     */
    @Input() fbControls: Address = {city_id: '', index: '', address: ''};
    @Input() fbGroup: FormGroup;

    /**
     * Использовать в качестве id города поле name_id из результатов фильтрации.
     * @type {boolean}
     */
    @Input() useNameId = true;

    /**
     * Имя города, отображаемое в селекте по-умолчанию.
     */
    @Input() defaultCityName: string;

    constructor(
        public kladrService: KladrService
    ) {}

    ngOnInit() {
        if (!this.defaultCityName) {
            this.defaultCityName = this.getCityNameFromControl();
        }
    }

    /**
     * При выборе города в селекте записываем в форму id этого города
     * @param e
     */
    public cityChanged(e: any): void {
        if (!this.kladrService.showedCities[e.value]) {
            return;
        }
        /**
         * Во избежание коллизий типов данных приводим city_id к строке
         */
        const cityId = this.fbGroup.get(`${this.fbControls.city_id}`);
        cityId.patchValue(e.value);
        cityId.markAsTouched();
        cityId.markAsDirty();
        cityId.updateValueAndValidity();

        /**
         * Если нужно еще и город сохранить, то сохраняем
         */
        if (this.fbControls.city) {
            const city = this.fbGroup.get(`${this.fbControls.city}`);
            city.patchValue(this.kladrService.showedCities[e.value]);
            city.markAsTouched();
            city.markAsDirty();
            city.updateValueAndValidity();
        }
    }

    /**
     * Получить адрес в формате Address
     * @returns {{}}
     */
    public getAddress(): Address {
        const result = new Address();
        Object.keys(this.fbControls).forEach(key => {
            result[key] = this.fbGroup.get(this.fbControls[key]).value;
        });

        return result;
    }

    /**
     * Утсановить адрес в формате Address в качестве текущего адреса
     * @param {Address} value
     */
    public setAddress(value: Address) {
        Object.keys(value).forEach(key => {
            const ctr = this.fbGroup.get(this.fbControls[key]);
            if (!ctr) {
                return;
            }
            ctr.patchValue(value[key]);
            ctr.markAsDirty();
            ctr.markAsTouched();
            ctr.updateValueAndValidity();
        });

        // Если есть город, то он теперь будет дефолтным
        if (value.city) {
            this.defaultCityName = value.city;
        }
    }

    /**
     * Получить дефолтное имя из поля city
     * @returns {any}
     */
    private getCityNameFromControl() {
        const cityField = this.fbControls.city;
        if (cityField && this.fbGroup.get(cityField)) {
            return this.fbGroup.get(cityField).value;
        }

        return null;
    }

    ngOnDestroy() {

    }
}
